import React from 'react';

import { BreadCrumbArrowIco } from 'components';

import { StyledBreadCrumbs } from './styled';

interface BreadCrumbsProps {
  items: string[];
}

export const BreadCrumbs = ({ items }: BreadCrumbsProps) => {
  return (
    <StyledBreadCrumbs>
      {items && (
        <div className="bread-crumbs">
          {items.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <div>{item}</div>
                {items.length !== index + 1 && <BreadCrumbArrowIco />}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </StyledBreadCrumbs>
  );
};
